import { PAGINATED_SIZE } from '@application/components/controllers/pages/BreedListPageController/constants';
import type { CardItemBreedData, StoreCardItemPromoData } from '@presentation/components';
import {
  CardItemBreed,
  CardItemContainer,
  CardItemWrapper,
  Container,
  EmptyOverlay,
  FiltersWithModal,
  Pagination,
  PaginationWrapper,
  StoreCardItemPromo,
} from '@presentation/components';
import type { FC } from 'react';
import type { BreedListPageProps } from '..';
import { Filters } from './components/Filters';
import { HeaderSearch } from './components/HeaderSearch';

export * from './types';

export const BreedListPage: FC<BreedListPageProps> = (props) => {
  const { items, pagination, isPromoItem, searchInput, filtersModal, loading = false } = props;

  return (
    <>
      <HeaderSearch searchInput={searchInput} />
      <Container>
        <FiltersWithModal {...filtersModal}>
          <Filters />
        </FiltersWithModal>
        {!loading && !items?.length && <EmptyOverlay />}
        <>
          <CardItemContainer>
            {!!loading &&
              Array(PAGINATED_SIZE)
                .fill(undefined)
                .map((_, index) => (
                  <CardItemWrapper key={index}>
                    <CardItemBreed loading />
                  </CardItemWrapper>
                ))}

            {!loading &&
              items.map((item, index) => (
                <CardItemWrapper key={index}>
                  {isPromoItem(index, PAGINATED_SIZE) ? (
                    <StoreCardItemPromo {...(item as StoreCardItemPromoData)} />
                  ) : (
                    <CardItemBreed {...(item as CardItemBreedData)} />
                  )}
                </CardItemWrapper>
              ))}
          </CardItemContainer>
          <PaginationWrapper>
            <Pagination marginPagesDisplayed={0} pageRangeDisplayed={2} {...pagination} />
          </PaginationWrapper>
        </>
      </Container>
    </>
  );
};
